<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>管理员列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="content_box">
      <div class="content_top">
        <router-link :to="{path:'/admin/add'}">
          <el-button type="primary" size="small" icon="el-icon-circle-plus-outline">添加管理员</el-button>
        </router-link>
      </div>
      <div class="content">
        <el-table border :data="adminList">
          <el-table-column prop="nickname" label="管理员昵称" align="center"></el-table-column>
          <el-table-column prop="email" label="登录邮箱" align="center"></el-table-column>
          <el-table-column prop="last_login_time" label="登录时间" align="center"></el-table-column>
          <el-table-column prop="status" label="状态" align="center">
            <template slot-scope="scope">{{ scope.row.status == 1 ? "禁用" : "启用"}}</template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="220">
            <template slot-scope="scope" v-if="scope.row.id != 1">
              <router-link :to="{ path : '/admin/update', query:{ id: scope.row.id}}">
                <el-button type="text" icon="el-icon-edit">修改</el-button>
              </router-link>
              <el-button
                v-if="scope.row.status == 1"
                class="success"
                type="text"
                @click="setStatus(scope.row.id, 0)"
                icon="el-icon-setting"
              >启用</el-button>
              <el-button
                v-else
                class="danger"
                type="text"
                @click="setStatus(scope.row.id, 1)"
                icon="el-icon-setting"
              >禁用</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="margin-top: 20px"
          background
          :page-sizes="[pageSize]"
          layout="total, sizes, prev, pager, next, jumper"
          :page-size="pageSize"
          :total="total"
          @current-change="currentChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      page: 1,
      total: 0,
      pageSize: 8,
      adminList: []
    };
  },
  methods: {
    currentChange(page) {
      this.page = page;
      this.getPowerList();
    },
    setStatus(id, status) {
      let _id = id;
      this.$confirm("是否要修改当前帐号状态?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$ajax({
            url: "/admin/status",
            data:{
              id: _id,
              status: status
            }
          }).then(data => {
            this.$util.msg(data.msg, "success");
            setTimeout(() => {
              this.getAdminList();
            }, 1200);
          });
        })
        .catch(() => {});
    },
    getAdminList() {
      this.$ajax({
        url: "/admin/index",
        data:{
          page: this.page,
          limit: this.pageSize
        }
      }).then(data => {
        this.adminList = data.data.data;
        this.total = data.data.count;
      });
    }
  },
  mounted() {
    this.getAdminList();
  }
};
</script>
<style>
</style>